import { api } from './api';

class AuthService {
    async login(username, password) {
        const response = await api.post('/api/auth/login', { username, password });
        localStorage.setItem('token', response.access_token);
        return response;
    }

    async logout() {
        try {
            await api.post('/api/auth/logout');
        } catch (error) {
            console.error('Logout error:', error);
        }
        localStorage.removeItem('token');
    }

    async getCurrentUser() {
        return api.get('/api/auth/me');
    }
}

export const authService = new AuthService();